'use client';

import dynamic from 'next/dynamic';
import type { VideoItem, VideoConsentLabels } from '@/app/_components/shared/video/video.types';
import { VideoSlide } from './video-slide';

// The multi-video carousel pulls embla. Load it lazily so single-video modules
// (the common case) ship no carousel JS at all.
const VideoCarousel = dynamic(() =>
  import('./video-carousel').then((m) => m.VideoCarousel)
);

interface VideoCarouselClientProps {
  items: VideoItem[];
  consentLabels?: VideoConsentLabels;
  imageSizes?: string;
  priority?: boolean;
  showNavigation?: boolean;
  showDots?: boolean;
  trackingPrefix?: string;
}

export function VideoCarouselClient({
  items,
  consentLabels,
  imageSizes,
  priority = false,
  showNavigation = true,
  showDots = true,
  trackingPrefix,
}: VideoCarouselClientProps) {
  // Single video - no carousel needed (no embla)
  if (items.length === 1) {
    return (
      <VideoSlide
        item={items[0]}
        isActive={true}
        imageSizes={imageSizes}
        priority={priority}
        consentLabels={consentLabels}
        trackingPrefix={trackingPrefix}
      />
    );
  }

  return (
    <VideoCarousel
      items={items}
      consentLabels={consentLabels}
      imageSizes={imageSizes}
      priority={priority}
      showNavigation={showNavigation}
      showDots={showDots}
      trackingPrefix={trackingPrefix}
    />
  );
}
